var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-email-events-modal',{attrs:{"show":_vm.show,"edit-subject":_vm.subject,"client-name":_vm.fullName,"sent-date":_vm.date,"events":_vm.events,"loading":_vm.eventsLoading},on:{"closed":_vm.onClosed}})}
var staticRenderFns = []

export { render, staticRenderFns }